module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-green-check-724fb2ba.svg";